import { useAddress, useContract } from '@thirdweb-dev/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAsyncFn } from 'react-use';

import { bigNumberToDecimal } from '@app/helpers/format';

export function useWithdrawLiquidityAvailability(_pairAddress?: string) {
  const address = useAddress();
  const { query } = useRouter();
  const pairAddress = _pairAddress ?? (query.id as string);

  const { contract: pairContract, isLoading } = useContract(pairAddress);

  const [{ value, loading }, getWithdrawBalance] = useAsyncFn(async () => {
    if (!pairContract) {
      return;
    }

    const decimals = await pairContract.call('decimals');

    const res = await pairContract.call('balanceOf', [address]);

    return res && decimals ? bigNumberToDecimal(res, decimals) : undefined;
  }, [pairContract, address]);

  useEffect(() => {
    getWithdrawBalance();
  }, [getWithdrawBalance]);

  return {
    isAllowedToWithdraw: value !== undefined && value > 0,
    balance: value,
    getWithdrawBalance,
    loading: isLoading || loading
  };
}
